import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import {useForm} from "react-hook-form";
import {ButtonMain, CheckboxesTags, DateCalendarForm} from "components";
import {fileDownload, FindLoad, renderName, renderPayerName, useModal} from "utils";
import {payerActions, patientsActions, vehiclesActions, httpRequestsOnLoadActions} from 'store';
import {Svg} from "assets";
import {EscortAppPatientList, LegTypesList} from "./constants";
import {legsService} from "../../store/legs/legs.service";


const ACTION_TYPE_EXPORT_CSV = 'ACTION_TYPE_EXPORT_CSV'

export const ExportCsv = ({params}) => {
    const {payersList, patientsList, vehiclesList} = useSelector((state) => ({
        payersList: state.payers?.payersList,
        patientsList: state.patients?.patientsList,
        vehiclesList: state.vehicles?.vehiclesList
    }));
    const dispatch = useDispatch()
    const {
        control,
        handleSubmit,
        watch,
    } = useForm();
    const loading = FindLoad(ACTION_TYPE_EXPORT_CSV)
    const {close} = useModal();
    const from = watch('from');


    useEffect(() => {
        dispatch(payerActions.getPayers());
        dispatch(patientsActions.getPatients());
        dispatch(vehiclesActions.getVehicles());
    }, []);

    const downLoadCSV = async (data) => {
        const sendParams = {
            ...data,
            from: moment.utc(data.from).format('YYYY-MM-DDT00:00:01'),
            to: moment.utc(data.to).format('YYYY-MM-DDT23:59:00'),
            ...params?.defaultParams
        }
        // data?.patient ? sendParams.patient = data?.patient : delete sendParams?.patient;
        // data?.payer ? sendParams.payer = data?.payer : delete sendParams?.payer
        // data?.status ? sendParams.status = data?.status : delete sendParams?.status
        // data?.vehicle ? sendParams.vehicle = data?.vehicle : delete sendParams?.vehicle;

        try {
            dispatch(httpRequestsOnLoadActions.appendLoading(ACTION_TYPE_EXPORT_CSV))
            const response = await legsService.getCsv(params?.path, sendParams);
            fileDownload(response?.data, 'legs')
        } catch (e) {

        } finally {
            dispatch(httpRequestsOnLoadActions.removeLoading(ACTION_TYPE_EXPORT_CSV))
            close();
        }
    }

    return (
        <form
            className='export-csv-wrapper'
            onSubmit={handleSubmit(downLoadCSV)}
        >
            <div className="modal-header-main">
                <h2 className="modal-header-title">Export CSV</h2>

                <button
                    className="modal-close-btn-main"
                    type="button"
                    onClick={close}
                >
                    <Svg.CloseSvg/>
                </button>
            </div>

            <div className="modal-body-main">
                <div className='flex-gap-16'>
                    <DateCalendarForm
                        name='from'
                        label='From'
                        max={watch("to")}
                        control={control}
                        rules={{
                            required: watch('from') ? false : 'This Field is required'
                        }}
                    />

                    <DateCalendarForm
                        name='to'
                        label='To'
                        min={watch("from")}
                        control={control}
                        rules={{
                            required: watch('to') ? false : 'This Field is required',
                            validate: (value) => {
                                if (!value || !from) return true;

                                const fromDate = moment(from);
                                const toDate = moment(value);

                                return toDate.diff(fromDate, 'months', true) <= 1 || 'The max allowed date range is 1 month.';
                            }
                        }}
                    />
                </div>

                <CheckboxesTags
                    limitTags={2}
                    multiple
                    list={LegTypesList}
                    renderLabel={(option) => option?.name}
                    name="types"
                    control={control}
                    labelHeader={'Types'}
                    placeholder="Select Option"
                    disableClearable={true}
                />

                <CheckboxesTags
                    limitTags={2}
                    multiple
                    list={payersList?.payers}
                    renderLabel={(option) => renderPayerName(option)}
                    name="payers"
                    control={control}
                    labelHeader={'Payer'}
                    placeholder="Select Option"
                    disableClearable={true}
                    loadType={"GET_PAYERS"}
                />

                <CheckboxesTags
                    limitTags={2}
                    multiple
                    list={patientsList?.patients}
                    renderLabel={(option) => renderName(option)}
                    name="patients"
                    control={control}
                    labelHeader={'Patient'}
                    placeholder="Select Option"
                    disableClearable={true}
                    loadType={"GET_PATIENTS"}
                />

                <div className='flex-gap-16'>
                    <CheckboxesTags
                        limitTags={1}
                        multiple
                        list={vehiclesList?.vehicles}
                        renderLabel={(option) => option?.unitNumber}
                        name="vehicles"
                        control={control}
                        labelHeader={'Vehicle'}
                        placeholder="Select Option"
                        disableClearable={true}
                        loadType={"GET_VEHICLES"}
                    />

                    {params?.status &&
                        <CheckboxesTags
                            limitTags={1}
                            multiple
                            list={EscortAppPatientList}
                            renderLabel={(option) => option?.name}
                            name="statuses"
                            control={control}
                            labelHeader={'Statuses'}
                            placeholder="Select Option"
                            disableClearable={true}
                        />
                    }
                </div>
            </div>

            <div className="modal-footer-main">
                <ButtonMain
                    text="Cancel"
                    cancel
                    buttonMainStyles={{
                        width: "fit-content",
                    }}
                    onClick={close}
                />
                <ButtonMain
                    text={'Export'}
                    load={loading}
                    type="submit"
                    buttonMainStyles={{
                        width: "86px",
                    }}
                />
            </div>
        </form>
    );
};

